import { Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import Layout from './components/Layout';
import Clients from './pages/Clients';
import MachineBrand from './pages/MachineBrand';
import Users from './pages/Users';
import MachineType from './pages/MachineType';
import Machines from './pages/Machines';
import MachineCharacteristics from './pages/MachineCharacteristics';
import MachineTypeCharacteristics from './pages/MachineTypeCharacteristics';
import TaskClasses from './pages/TaskClasses';
import Statuses from './pages/Statuses';
import WorkOrders from './pages/WorkOrders';
import MachineDetails from './pages/MachineView';
import WorkOrderDetails from './pages/WorkOrderView';
import LoginPage from './pages/LoginPage';
import { AuthProvider, useAuth } from './context/AuthContext';
import Dashboard from './pages/Dashboard';
import MachineTypeTaskClasses from './pages/MachineTypeTaskClasses';
const PrivateRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? children : <Navigate to="/login" />;
};


const App = () => {
  return (
    <div className="App">
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Navigate to="/login" />} />
          <Route path="/login" element={<LoginPage />} />
          <Route element={<PrivateRoute> <Layout /> </PrivateRoute>}>
            <Route path="/dashboard" element={<Dashboard/>} />
            <Route path="/clients" element={<Clients />} />
            <Route path="/machine-brand" element={<MachineBrand />} />
            <Route path="/machine-types" element={<MachineType />} />
            <Route path="/machines" element={<Machines />} />
            <Route path="/machine-characteristics" element={<MachineCharacteristics />} />
            <Route path="/machine-type-characteristics" element={<MachineTypeCharacteristics />} />
            <Route path="/task-classes" element={<TaskClasses />} />
            <Route path="/machine-type-task-classes" element={<MachineTypeTaskClasses />} />
            <Route path="/users" element={<Users />} />
            <Route path="/statuses" element={<Statuses />} />
            <Route path="/work-orders" element={<WorkOrders />} />
            <Route path="/machines/:uuid" element={<MachineDetails />} />
            <Route path="/work-orders/:uuid" element={<WorkOrderDetails />} />
            <Route path="/home" element={<Navigate to="https://www.fabrifor.com/" replace />} />
          </Route>
        </Routes>
      </AuthProvider>
    </div>
  );
};
  
export default App;
